import { render, staticRenderFns } from "./ContattiAreaManager.vue?vue&type=template&id=094bd396&"
import script from "./ContattiAreaManager.vue?vue&type=script&lang=js&"
export * from "./ContattiAreaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports